module.exports = __webpack_public_path__ + "assets/imgs/bg.76bc8b57.png";